//
// Dynamics.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../core/GTLModel";
import "./DynamicRole";
import "./DynamicString";
import "./DynamicRangeAttributesMap";
import "./DynamicGroup";
import "./Dynamic";

var Dynamics = createModule("gtl::Dynamics", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        dynamicRoles: [1],
        dynamicStrings: [1],
        groups: [1],
        dynamicRangeAttributesMaps: [1],
    },
    ,
    ,
    {
        getDynamicForName: [1,7],
        getDynamicStringForName: [1,7],
        getDynamicRangeAttributesMapForName: [1,7],
        getDynamicRoleForName: [1,7],
    },
    {
        _create: [4],
    },
    ,
]);
export default Dynamics;
